import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEO from '@/components/feature/SEO';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '吃瓜视频网',
        url: 'https://www.chiguavideo.com',
        description: '吃瓜视频网汇聚吃瓜视频在线播放与在线观看吃瓜视频核心入口，同步更新国产吃瓜视频及吃瓜视频网站热门爆料。',
        foundingDate: '2024',
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          email: 'contact@chiguavideo.com',
        },
      },
      {
        '@type': 'WebPage',
        name: '关于我们 - 吃瓜视频网',
        url: 'https://www.chiguavideo.com/about',
        description: '了解吃瓜视频网的品牌故事、团队背景、平台口碑与联系方式。',
        isPartOf: { '@id': 'https://www.chiguavideo.com/#website' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://www.chiguavideo.com/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
            item: 'https://www.chiguavideo.com/about',
          },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '吃瓜视频网的内容来源是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们的内容来自全网公开信息的整理与聚合，包括社交媒体、新闻报道、官方公告等公开渠道。我们不对原始信息进行篡改，仅做结构化整理和呈现。',
            },
          },
          {
            '@type': 'Question',
            name: '如何确保信息的真实性和可靠性？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '我们建立了严格的信息核实机制，每条爆料内容都会标注信息来源，并尽可能多方交叉验证。对于未经证实的信息，我们会明确标注"待核实"。',
            },
          },
          {
            '@type': 'Question',
            name: '可以在吃瓜视频网上发布自己的视频吗？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '目前吃瓜视频网以内容聚合为主，暂不支持用户自行上传视频。如果您有优质内容推荐或爆料线索，可以通过联系我们页面与我们取得联系。',
            },
          },
          {
            '@type': 'Question',
            name: '如何联系吃瓜视频网进行商务合作或内容申诉？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过以下方式联系我们：发送邮件至 contact@chiguavideo.com，或在"联系我们"板块填写表单。我们会在24小时内回复您的来信。对于内容申诉类请求，我们会优先处理。',
            },
          },
          {
            '@type': 'Question',
            name: '吃瓜视频网是否收费？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '吃瓜视频网目前所有内容均为免费浏览，不向用户收取任何费用。我们致力于为瓜友提供最优质的免费吃瓜体验。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们 - 吃瓜视频网 | 品牌介绍与联系方式"
        description="了解吃瓜视频网的品牌故事、团队背景、平台口碑与联系方式。吃瓜视频网汇聚吃瓜视频在线播放与在线观看吃瓜视频核心入口，同步更新国产吃瓜视频及吃瓜视频网站热门爆料。"
        keywords="吃瓜视频网,关于我们,品牌介绍,联系方式,商务合作,吃瓜视频,吃瓜视频在线播放"
        canonicalUrl="https://www.chiguavideo.com/about"
        ogTitle="关于我们 - 吃瓜视频网"
        ogDescription="了解吃瓜视频网的品牌故事、团队背景、平台口碑与联系方式。"
        ogUrl="https://www.chiguavideo.com/about"
        ogType="website"
        jsonLd={jsonLd}
      />

      <Navbar />

      <main className="pt-16 bg-background-50">
        <section className="w-full bg-background-50">
          <div className="w-full px-4 md:px-6 pt-12 pb-10 md:pt-16 md:pb-14">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
          </div>
        </section>

        <section className="w-full bg-background-50 pb-16 md:pb-20">
          <div className="w-full px-4 md:px-6 text-center">
            <span className="inline-block px-4 py-1.5 border border-primary-500/50 text-primary-500 text-xs font-medium rounded-full mb-6 whitespace-nowrap">
              关于吃瓜视频
            </span>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-[1.15] max-w-3xl mx-auto mb-6">
              全网最真实
              <br />
              最及时的
              <br />
              娱乐爆料平台
            </h1>
            <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
              吃瓜视频网诞生于2024年，由一群热爱娱乐资讯的内容创作者共同发起。我们致力于为全网吃瓜群众提供最新、最全、最真实的娱乐八卦和热点视频内容。
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-foreground-950 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                商务合作
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-full hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                加入我们
              </a>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5 mt-14 max-w-4xl mx-auto">
              {[
                { icon: 'ri-eye-line', label: '日均浏览量', value: '500万+' },
                { icon: 'ri-user-line', label: '活跃用户', value: '120万+' },
                { icon: 'ri-article-line', label: '累计内容', value: '1.2万+' },
                { icon: 'ri-team-line', label: '编辑团队', value: '50+人' },
                { icon: 'ri-trophy-line', label: '行业口碑', value: 'TOP 3' },
              ].map((stat, i) => (
                <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
                  <i className={`${stat.icon} text-2xl text-primary-500 mb-3 block`}></i>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-xs font-medium text-primary-500 uppercase tracking-wider whitespace-nowrap">
                  平台优势
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
                为什么选择
                <br />
                吃瓜视频网
              </h2>
              <p className="text-base text-foreground-600 max-w-lg mx-auto">
                五大核心优势，打造最专业吃瓜体验
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
              {[
                { icon: 'ri-speed-line', title: '实时更新', desc: '7×24小时不间断监测全网热点，第一时间为你推送最新猛料' },
                { icon: 'ri-shield-check-line', title: '真实可靠', desc: '严格的信息核实机制，每条爆料标明出处，确保内容真实可信' },
                { icon: 'ri-stack-line', title: '内容全面', desc: '覆盖明星八卦、网红大瓜、塌房现场、影视解析等全品类内容' },
                { icon: 'ri-smartphone-line', title: '体验流畅', desc: '精心设计的界面布局，无论电脑还是手机都能畅快刷瓜' },
                { icon: 'ri-heart-line', title: '瓜友社区', desc: '活跃的评论区互动氛围，和百万瓜友一起快乐吃瓜' },
                { icon: 'ri-shield-star-line', title: '隐私保护', desc: '严格保护用户隐私，不追踪个人浏览记录，放心使用' },
              ].map((feat, i) => (
                <div key={i} className="group p-6 md:p-7 rounded-xl bg-background-100 hover:bg-primary-500 transition-all duration-300">
                  <div className="w-12 h-12 rounded-xl bg-background-200 group-hover:bg-background-50/20 flex items-center justify-center mb-5 transition-colors duration-300">
                    <i className={`${feat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-foreground-950 group-hover:text-background-50 mb-2 transition-colors duration-300">
                    {feat.title}
                  </h3>
                  <p className="text-sm text-foreground-600 group-hover:text-background-50/80 transition-colors duration-300 leading-relaxed">
                    {feat.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-900 py-16 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-12">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                <span className="text-xs font-medium text-primary-500 uppercase tracking-wider whitespace-nowrap">
                  媒体评价
                </span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 mb-3">
                业界口碑
              </h2>
              <p className="text-base text-foreground-600 max-w-lg mx-auto">
                来自媒体同行和合作伙伴的真实评价
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
              {[
                { name: '娱乐周刊', role: '行业媒体', rating: 5, text: '吃瓜视频网已经成为娱乐资讯领域不可忽视的力量，其内容整理能力和更新速度在同行中名列前茅。' },
                { name: '新媒体观察', role: '科技媒体', rating: 5, text: '作为内容聚合平台的代表，吃瓜视频网在用户体验和信息架构方面做出了很好的示范。' },
                { name: '网红经济报', role: '财经媒体', rating: 4, text: '吃瓜视频网精准把握了年轻用户对娱乐资讯的需求，内容选品和推送机制值得行业借鉴。' },
              ].map((review, i) => (
                <article key={i} className="bg-background-50 rounded-xl p-6 md:p-7">
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`text-sm ${j < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-400'}`}
                      ></i>
                    ))}
                  </div>
                  <h3 className="text-base font-bold text-foreground-50 mb-3">{review.name}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-5">{review.text}</p>
                  <span className="text-xs text-foreground-500">{review.role}</span>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section id="contact" className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto mb-10">
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
                开启合作
              </h2>
              <p className="text-base md:text-lg text-foreground-600 mb-8">
                无论是商务合作、内容投稿还是意见建议，我们都期待听到你的声音
              </p>
            </div>

            <div className="max-w-md mx-auto bg-background-100 rounded-2xl p-6 md:p-8">
              <h3 className="text-lg font-bold text-foreground-950 mb-6">联系我们</h3>

              <div className="space-y-4">
                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50">
                  <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">电子邮箱</div>
                    <a href="mailto:contact@chiguavideo.com" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
                      contact@chiguavideo.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50">
                  <div className="w-10 h-10 rounded-lg bg-secondary-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-wechat-line text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">微信公众号</div>
                    <span className="text-sm text-foreground-600">搜索"吃瓜视频网"关注我们</span>
                  </div>
                </div>

                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50">
                  <div className="w-10 h-10 rounded-lg bg-accent-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-video-line text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">抖音</div>
                    <span className="text-sm text-foreground-600">@chiguavideo 每日更新</span>
                  </div>
                </div>

                <div className="flex items-center gap-3 p-4 rounded-lg bg-background-50">
                  <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                    <i className="ri-bilibili-line text-background-50"></i>
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-950">B站</div>
                    <span className="text-sm text-foreground-600">@吃瓜视频网官方</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}